import { BuildBadge } from "./BuildBadge.js";
import "./HoldingScreen.css";

export interface HoldingScreenProps {
  message: string;
  detail?: string;
}

/**
 * The only thing allowed on screen when something isn't right. Never a stack trace, never raw
 * error text — this is a screen in a customer's venue, unattended.
 */
export function HoldingScreen(props: HoldingScreenProps): React.JSX.Element {
  return (
    <div className="holding-screen">
      <div className="holding-screen__mark" aria-hidden="true" />
      <p className="holding-screen__message">{props.message}</p>
      {props.detail ? <p className="holding-screen__detail">{props.detail}</p> : null}
      <BuildBadge />
    </div>
  );
}
